import React from 'react';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../CategoryCard';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {SwitchCustom, TextBox} from '../../../Core/UI';
import {Grid} from '@material-ui/core';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import DateFnsUtils from '@date-io/date-fns';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type CriminalOffenseProps = {
    parameters: Approval;
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    index: number;
};

const CriminalOffense = observer(({parameters, valueChanged, setCategory, index}: CriminalOffenseProps) => {
    return (
        <CategoryCard title={'Criminal offense'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Type of charge',
                        name: 'criminalOffenseChargeType',
                        options: fieldOptions.criminalOffenseChargeType.options,
                        ...parameters.criminalOffenseChargeType,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="criminalOffenseType"
                    label="What was the type of offense?"
                    value={parameters.criminalOffenseType?.value}
                    onChange={(value) => valueChanged(parameters.criminalOffenseType, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'criminalOffenseIncarcerated',
                        label: 'Were you incarcerated?',
                        ...parameters.criminalOffenseIncarcerated,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            {parameters.criminalOffenseIncarcerated.value && (
                <>
                    <Grid item xs={4}>
                        <TextBox
                            id="criminalOffenseIncarcerationYear"
                            label="Year of incarceration (YYYY)"
                            type="number"
                            value={parameters.criminalOffenseIncarcerationYear?.value}
                            onChange={(value) => valueChanged(parameters.criminalOffenseIncarcerationYear, value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextBox
                            id="criminalOffenseIncarcerationYearOut"
                            label="Year out of prison (YYYY)"
                            type="number"
                            value={parameters.criminalOffenseIncarcerationYearOut?.value}
                            onChange={(value) => valueChanged(parameters.criminalOffenseIncarcerationYearOut, value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SwitchCustom
                            param={{
                                name: 'criminalOffenseProbation',
                                label: 'Any probation or parole?',
                                ...parameters.criminalOffenseProbation,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                </>
            )}
            <Grid item xs={4}>
                <TextBox
                    id="criminalOffenseDetails"
                    label="Details on the criminal offense"
                    value={parameters.criminalOffenseDetails?.value}
                    onChange={(value) => valueChanged(parameters.criminalOffenseDetails, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        inputVariant="outlined"
                        variant="inline"
                        openTo="year"
                        views={['year', 'month']}
                        label="When did it happen?"
                        style={{width: '100%', marginTop: 8}}
                        value={parameters.criminalOffenseDate?.value || null}
                        onChange={(date) => valueChanged(parameters.criminalOffenseDate, date)}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'When did you complete parole?',
                        name: 'criminalParole',
                        options: fieldOptions.criminalParole.options,
                        ...parameters.criminalParole,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="criminalOffenseNotes"
                    label="Notes"
                    value={parameters.criminalOffenseNotes?.value}
                    onChange={(value) => valueChanged(parameters.criminalOffenseNotes, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default CriminalOffense;
